import React from 'react';
import { days } from '../../utils/constants';
import { useSelector } from 'react-redux';
const DaysWeek = ({ selectDays, selectedDays,error }) => {
  const { recurrenceRule, frequencyShow, selectedCategoryOption } = useSelector((state) => state.createOrderSlice)

  const dynamicStyles = (item) => {
    return {
      backgroundColor: recurrenceRule?.days?.includes(item?.value) ? '#ff4444' : 'transparent',
      color: recurrenceRule?.days?.includes(item?.value) ? '#fff' : 'inherit',
      pointerEvents: (selectedCategoryOption?.value === 7) ? 'none' : (recurrenceRule?.days?.length === frequencyShow && !recurrenceRule?.days?.includes(item?.value)) ? 'none' : 'auto',
      cursor: 'pointer',
    }
  };
  


  return (
    <>
      <div className='week-wrap'>
        {selectedCategoryOption?.value !== 7 && <h4>Select which of the <span className='colour-red'>{frequencyShow}</span> {frequencyShow > 1 ? "days" : "day"} of a week : </h4>}
        <ul className='list-unstyled'>
          {days?.map((val, idx) => {
            return (
              <>
                <li
                  style={dynamicStyles(val)}
                  onClick={() => selectDays(val)}>{val?.title}</li>
              </>
            )
          })}



        </ul>
        {error ? recurrenceRule?.days?.length===0 && <p className='form-error-message'>This field is required</p> :null}

      </div>


    </>
  );
}

export default DaysWeek;
